import { reportFrontendError } from './frontendErrorReport';
const markerKey = 'beauti:chunk-reload-attempted';
const outcomeKey = 'beauti:chunk-recovery-reported';
const referencePattern = /^EB-[A-Z0-9]{6,16}-[A-Z0-9]{1,8}$/;

// A resource timing entry is optional. Never fetch a URL to diagnose it, and
// never transmit an origin, arbitrary path, query, fragment or raw exception.
export const chunkErrorContext = (error, decision = {}) => {
  let asset = '',
    entry;
  try {
    const url = new URL(error?.request, window.location.href);
    const match = url.pathname.match(/^\/static\/(?:js|css)\/((?:main|[0-9]{1,10})\.[a-f0-9]{8,64}(?:\.chunk)?\.(?:js|css))$/);
    if (match) {
      asset = match[1];
      entry = performance.getEntriesByName?.(url.href)?.slice(-1)[0];
    }
  } catch {}
  return {
    asset,
    status: entry?.responseStatus || 0,
    cache: entry?.transferSize > 0 ? 'network' : entry?.transferSize === 0 && entry?.decodedBodySize > 0 ? 'cache' : 'unknown',
    action: decision.action,
    reference: decision.reference,
    fromRelease: decision.fromRelease
  };
};
export const reportReloadedLazyContentMount = () => {
  try {
    const marker = JSON.parse(sessionStorage.getItem(markerKey));
    if (!Number.isFinite(performance.timeOrigin) || performance.getEntriesByType?.('navigation')?.[0]?.type !== 'reload') return;
    // Only a fresh marker from a prior document can describe this reload.
    // A route mount in the original failing document is not recovery success.
    if (!referencePattern.test(marker?.reference || '') || !Number.isFinite(marker.at) || marker.at >= performance.timeOrigin || Date.now() - marker.at > 600000 || Date.now() < marker.at || sessionStorage.getItem(outcomeKey) === marker.reference) return;
    sessionStorage.setItem(outcomeKey, marker.reference);
    reportFrontendError({
      reference: `EB-${Date.now().toString(36).padStart(6, '0')}-${Math.random().toString(36).slice(2, 6)}`.toUpperCase(),
      error: {
        name: 'ChunkLoadError',
        message: 'Loading chunk recovery.'
      },
      chunk: {
        action: 'lazy_content_mounted',
        reference: marker.reference,
        fromRelease: marker.release
      }
    });
  } catch {}
};
